export default class extends HTMLElement {
  connectedCallback () {
    this.apply(this.checkedValue() || 'monthly')

    this.radios().forEach((radio) => {
      radio.addEventListener('change', this.handleChange)
    })
  }

  disconnectedCallback () {
    this.radios().forEach((radio) => {
      radio.removeEventListener('change', this.handleChange)
    })
  }

  handleChange = (event) => {
    this.apply(event.target.value)
  }

  radios () {
    return this.querySelectorAll('input[name="billing-cycle"]')
  }

  checkedValue () {
    return this.querySelector('input[name="billing-cycle"]:checked')?.value
  }

  apply (cycle) {
    document.querySelectorAll('[data-pricing-monthly], [data-pricing-cta-monthly]').forEach((el) => {
      el.classList.toggle('hidden', cycle !== 'monthly')
    })
    document.querySelectorAll('[data-pricing-yearly], [data-pricing-cta-yearly]').forEach((el) => {
      el.classList.toggle('hidden', cycle !== 'yearly')
    })
  }
}
